import React, {ReactNode} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Button, TextField, Typography} from "@material-ui/core";
import {INotificacion, IParcela} from "../../../types";
import EsIcon from "../../../icons/PNGs/es.png"
import EnIcon from "../../../icons/PNGs/en.png"
import config from "../../../config.json";
import {userService} from "../../../services/UserService";

const texts = require('../../../texts/configuracion.json');


interface IProps {
    notify(notification: INotificacion): void
    changeLanguage(idioma: string): void
    idioma: string
}

interface IState {
    text: Record<string, string>
}

class MobileIdioma extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%',
                    marginLeft: 20
                }}
            >

                <img
                    style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50,
                        marginRight: 20,
                        cursor: "pointer",
                        opacity: this.props.idioma === "es"? 1 : 0.3
                    }}
                    onClick={() => {
                        if (this.props.idioma !== "es") {
                            this.props.changeLanguage("es")
                            axios.get(
                                config.url+`/cambiar/idioma?lang=es`,
                                {auth: {
                                        username: `${userService.getUser()}`,
                                        password: `${userService.getPass()}`
                                    }})
                                .then(() => {})
                                .catch(() => this.props.notify({message: texts["es"]["33"], variant: 'error'}))
                        }
                    }}
                    src={EsIcon}
                    alt={'es'}
                />



                <img
                    style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50,
                        cursor: "pointer",
                        opacity: this.props.idioma === "en"? 1 : 0.3
                    }}
                    onClick={() => {
                        if (this.props.idioma !== "en") {
                            this.props.changeLanguage("en")

                            axios.get(
                                config.url+`/cambiar/idioma?lang=en`,
                                {auth: {
                                        username: `${userService.getUser()}`,
                                        password: `${userService.getPass()}`
                                    }})
                                .then(() => {})
                                .catch(() => this.props.notify({message: texts["en"]["33"], variant: 'error'}))
                        }
                    }}
                    src={EnIcon}
                    alt={'en'}
                />

            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    changeLanguage: (idioma: string) => dispatch({type: 'choose-config-idioma', idioma})
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileIdioma);